import { render } from "./SmsIdentifyComplete.vue?vue&type=template&id=703896ba&scoped=true"
import script from "./SmsIdentifyComplete.vue?vue&type=script&lang=js"
export * from "./SmsIdentifyComplete.vue?vue&type=script&lang=js"

import "./SmsIdentifyComplete.vue?vue&type=style&index=0&id=703896ba&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703896ba"]])

export default __exports__